import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TOrderSyncRequest, TOrdersSyncStore } from './types';

export const initialState: TOrdersSyncStore = {
	syncShopifyLoader: false,
	syncWixLoader: false,
	syncShopwareLoader: false,
};

const ordersSync = createSlice({
	name: '@@ordersSync',
	initialState,
	reducers: {
		syncOrderShopifyRequest: (
			state: TOrdersSyncStore,
			_action: PayloadAction<TOrderSyncRequest>,
		) => {
			const next = state;
			next.syncShopifyLoader = true;
		},
		syncOrderShopifySuccess: (state: TOrdersSyncStore) => {
			const next = state;
			next.syncShopifyLoader = false;
		},
		syncOrderWixRequest: (state: TOrdersSyncStore, _action: PayloadAction<TOrderSyncRequest>) => {
			const next = state;
			next.syncWixLoader = true;
		},
		syncOrderWixSuccess: (state: TOrdersSyncStore) => {
			const next = state;
			next.syncWixLoader = false;
		},
		syncOrderShopwareRequest: (
			state: TOrdersSyncStore,
			_action: PayloadAction<TOrderSyncRequest>,
		) => {
			const next = state;
			next.syncShopwareLoader = true;
		},
		syncOrderShopwareSuccess: (state: TOrdersSyncStore) => {
			const next = state;
			next.syncShopwareLoader = false;
		},
		ordersSyncInitState: () => initialState,
	},
});

export default ordersSync.reducer;
export const {
	syncOrderShopifyRequest,
	syncOrderShopifySuccess,
	syncOrderWixRequest,
	syncOrderWixSuccess,
	syncOrderShopwareRequest,
	syncOrderShopwareSuccess,
	ordersSyncInitState,
} = ordersSync.actions;
